import { Component, Emit, Model, Prop, Vue, Watch } from 'vue-property-decorator';
import moment from 'moment/moment';
import AskConversation from '@/v2/home/ask-goover/ask-conversation/ask-conversation.vue';
import type { ConversationInfo } from '@/shared/model/ask-goover.model';
import { namespace } from 'vuex-class';
// hoặc dùng JSON.parse(JSON.stringify(...))
import cloneDeep from 'lodash/cloneDeep';
import GoModal from '@/core/go-modal/go-modal.vue';

const briefingStore = namespace('briefingStore');

@Component({
  methods: {},
  mixins: [],
  components: {
    'go-modal': GoModal,
    'ask-sub': AskConversation,
  },
  computed: {
    moment() {
      return moment;
    },
  },
})
export default class ChatHistoryModalComponent extends Vue {
  @Model('open', { type: Boolean, required: true }) open!: boolean;
  @Prop({ type: Object }) readonly item!: ConversationInfo;

  @briefingStore.Getter
  getReferenceDocuments!: Array<any>;

  isDeepAnswer = false;

  @Emit('close') close() {}

  @Emit('bookmark')
  bookmark(model: ConversationInfo) {
    this.localItem = { ...this.localItem, isBookmark: !model.isBookmark };
    console.log('local item ', this.localItem);
    return model;
  }

  @Emit('share')
  share(conversationId: string) {
    return conversationId;
  }

  localItem: ConversationInfo = {} as ConversationInfo;

  @Watch('item', { immediate: true, deep: true })
  onItemChange() {
    this.cloneItem();
  }

  cloneItem() {
    this.localItem = cloneDeep(this.item);
  }
}
